import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { CollectionSection } from '../../components/CollectionSection';
import { SliderSection, translateSectionTitle } from '../../components/SliderSection';
import { useGetSuggestionSections } from '../../hooks/useGetSuggestionSections';
import { useSplitSuggestionSections } from '../../hooks/useSplitSuggestionSections';
import { createMockCollection, createMockListing } from '../../queries/mockHomepageData';
import { AllSection } from './AllSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProductHomeSections({
  productType
}) {
  const {
    loading,
    error,
    data
  } = useGetSuggestionSections({
    productTypes: [productType]
  });
  const {
    sections,
    remainingSections
  } = useSplitSuggestionSections({
    suggestionSections: data === null || data === void 0 ? void 0 : data.result.sections,
    start: 0,
    end: 1
  });
  const collection = createMockCollection();
  const listings = Array.from({
    length: 6
  }, createMockListing);
  if (loading) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true
  });
  if (error) return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest"
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [sections === null || sections === void 0 ? void 0 : sections.map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
      title: translateSectionTitle(section.sectionType),
      cards: section.cards
    }, index)), /*#__PURE__*/_jsx(CollectionSection, {
      title: collection.name,
      description: collection.description,
      imageUrl: collection.imageSrc,
      collectionSlug: collection.name,
      cards: listings,
      collectionId: collection.collectionId
    }), remainingSections === null || remainingSections === void 0 ? void 0 : remainingSections.map((section, index) => /*#__PURE__*/_jsx(SliderSection, {
      title: translateSectionTitle(section.sectionType),
      cards: section.cards
    }, index)), /*#__PURE__*/_jsx(AllSection, {
      productType: productType
    })]
  });
}